<div class="container simple" [class.noStyling]="simpleStyling">
  <iframe loading="lazy" class="video" [src]='safeURL' frameborder="0" allowfullscreen></iframe>
</div>
